export default "__VITE_ASSET__1Fuz7Jmk__"